export default "__VITE_ASSET__CPb$7KiO__"